import axios from 'axios'
import services from '@/services'
import { Store, USER } from '@/store'
import loggerService, { LOG_SUCCESS, LOG_ERROR } from './logger'

const httpClient = axios.create()
const notifyError = (data) => {
  services.event.emitEvent(services.event.BASIC_ACTIONS.ERROR, { type: 'error', msg: ((data || {}).msg || 'error.notNetwork') })
}
const validateError = ({ status }) => {
  if (status === 401) {
    Store.commit(USER.MUTATIONS.REMOVE_ALL_USERS)
    window.location.reload()
  }
}
httpClient.interceptors.response.use((response) => {
  loggerService.log('plaka', `${response.config.url}-${response.status}`, LOG_SUCCESS)
  return response
}, (error) => {
  const response = (error.response || error).config
  loggerService.log('plaka', `${response.url}-${response.status}-${response.statusText}`, LOG_ERROR)
  validateError((error.response || error))
  notifyError((error.response || error).data)
  return Promise.reject(error.response)
})

export default httpClient
